
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCheckGoogle as ObiCheckGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-check-google.js';
 
 
 

 
 export const ObiCheckGoogle = createComponent({
   react: React,
   tagName: 'obi-check-google',
   elementClass: ObiCheckGoogleElement,
   events: {
     
   }
  });
 
 